import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getGetJobs = async () => {
  const { data } = await axios.get(`${api_base_url}/Job/GetJobs`);
  return data;
};
export const getJobConfigReport = async (jobId) => {
  const { data } = await axios.get(
    `${api_base_url}/Job/GetJobConfigReport/${jobId}`
  );
  return data;
};
export const getEmailLogs = async (eventId) => {
  const { data } = await axios.get(
    `${api_base_url}/Job/GetEmailLogs/${eventId}`
  );
  return data;
};
// Update Job
export const updateJob = async (jobUdpatedData) => {
  if (Array.isArray(jobUdpatedData.scheduleDays)) {
    jobUdpatedData.scheduleDays =
      jobUdpatedData.scheduleDays &&
      jobUdpatedData.scheduleDays.map((x) => x?.value)?.join(",");
  } else if (typeof jobUdpatedData.scheduleDays === "object") {
    jobUdpatedData.scheduleDays = jobUdpatedData.scheduleDays;
  }
  return await axios.put(`${api_base_url}/Job/UpdateHangfireJob`, {
    ...jobUdpatedData,
  });
};
export const addJobs = async (addJobsData) => {
  if (Array.isArray(addJobsData.scheduleDays)) {
    addJobsData.scheduleDays =
      addJobsData.scheduleDays &&
      addJobsData.scheduleDays.map((x) => x?.value)?.join(",");
  } else if (typeof addJobsData.scheduleDays === "object") {
    addJobsData.scheduleDays = addJobsData.scheduleDays;
  }
  return await axios.post(`${api_base_url}/Job/AddHangfireJob`, {
    ...addJobsData,
  });
};

export const deleteJobs = async (ids) => {
  return await axios.delete(`${api_base_url}/Job/DeactivateHangfireJobs`, {
    data: ids,
  });
};

export const getJobDetailsById = async (jobId) => {
  const { data } = await axios.get(
    `${api_base_url}/Job/GetJobDetailsById/${jobId}`
  );
  return data;
};

export const executeJob = async (job) => {
  return await axios.put(`${api_base_url}/Job/ExecuteHangfireJob`, {
    ...job,
  });
};

export const getExecutionHistory = async (jobConfigId) => {
  const { data } = await axios.get(
    `${api_base_url}/Job/GetExecutionHistory/${jobConfigId}`
  );
  return data;
};
